module.exports = __webpack_public_path__ + "media/components/country-flag/static/tm-88a4d5fd27779e6867a8f09baf659733.svg";